import { ref } from '@nuxtjs/composition-api';
import useTlmCart from '~/composable/useTlmCart';
import { FLOW_STATUS } from '~/constants/CheckoutFlow';
import useErrorHandler from '~/composable/useErrorHandler';

export default function useCustomer (appContext) {
  const hubbleClient = appContext.$hubble;
  const { performFlowFailure, catchApiFailureWithNoAction } = useErrorHandler()
  const { updateCart } = useTlmCart(appContext);
  const error = ref({});

  if (!appContext || !hubbleClient) {
    throw new Error('You must provide the nuxt app context to use this composable');
  }


  const addAddressInformation = async (customerDetails) => {
    try {
      const response = await hubbleClient.customer.addAddressInformation(customerDetails)
        .catch(() => {
          performFlowFailure()
        })
      if (response.data.status === FLOW_STATUS.ERROR) {
        performFlowFailure()
      }
      updateCart(response.data.responseObject)
      return response
    } catch (error) {
      catchApiFailureWithNoAction(error)
    }
  }
  /**
   *  This function is used to add saved address(if found ) information to the cart
   * @param cartID the id of the cart that the address information should be added to
   * @param tempAddressIdentifier is a unique identifier for the address that should be added to the cart,
   * typically this is the mitID access token or the cvr number
   * @returns {Promise<*>}
   */
  const addSavedAddressInformation = async (cartID, tempAddressIdentifier) => {
    try {
      const response = await hubbleClient.checkout.addSavedAddressToCart(cartID, tempAddressIdentifier)
        .catch(() => {
          performFlowFailure()
        })
      updateCart(response.data.responseObject)
      return response.data
    } catch (error) {
      catchApiFailureWithNoAction(error)
    }
  }


  return {
    addSavedAddressInformation,
    addAddressInformation,
    error
  }
}
